import { ReactNode } from 'react';
import { Stack } from '@mui/material';
import { IProductDto } from 'api/products/dto';
import CollapsibleSection from 'components/v2/accordion/CollapsibleSection';
import OrderItem from 'components/v2/text/OrderItem';
import { CurrencyCode } from 'constants/enums/general';
import { useLocalization } from 'localization';
import { userStore } from 'stores/userStore';

type OrderSection = {
  products: IProductDto[];
  title: string | ReactNode;
  subTitle?: string | ReactNode;
  packageCurrency?: string;
};

const NewProductSection = (props: OrderSection) => {
  const { products, title, packageCurrency = CurrencyCode.DKK, subTitle } = props;
  const { f } = useLocalization();
  const { user } = userStore();
  const showPrice = user?.visiblePrices;

  return (
    <CollapsibleSection title={title} subTitle={subTitle}>
      <Stack gap={1.25}>
        {products
          .filter(p => p?.quantity && p?.id)
          .map((p: IProductDto, index) => {
            return (
              <OrderItem
                visiblePrice={showPrice}
                key={index}
                name={p.name}
                quantity={p.quantity ?? 1}
                price={
                  showPrice
                    ? `(${f((p?.discountedPrice ?? 0) * (p?.quantity ?? 0), { currency: packageCurrency, decimals: 2 })})`
                    : ''
                }
              />
            );
          })}
      </Stack>
    </CollapsibleSection>
  );
};

export default NewProductSection;
